import React from 'react';

import type { SiteConfig } from 'src/context/site-context';
import { SiteContext } from 'src/context/site-context';

const SiteConsumer = ({
  children,
}: {
  children: ({
    siteId,
    language,
    buildType,
    styling,
    basePath,
    untranslatedPath,
    seo,
  }: SiteConfig) => React.ReactNode;
}) => (
  <SiteContext.Consumer>
    {({
      siteId,
      language,
      buildType,
      isGlobalPage,
      styling,
      basePath,
      untranslatedPath,
      isMeridian,
      isHarbour,
      isDL,
      pageLevel,
      seo,
    }) =>
      children({
        siteId,
        language,
        buildType,
        isGlobalPage,
        styling,
        basePath,
        untranslatedPath,
        isMeridian,
        isHarbour,
        isDL,
        pageLevel,
        seo,
      })
    }
  </SiteContext.Consumer>
);

export default SiteConsumer;
